import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { useLanguage, dfLocale } from "../i18n";
import { Reveal } from "./Reveal";

export const BlogTeaser = () => {
  const { t, lang } = useLanguage();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get(`/posts?lang=${lang}&limit=3`).then((r) => setPosts(r.data)).catch(() => {});
  }, [lang]);

  if (posts.length === 0) return null;

  return (
    <section className="pb-24 sm:pb-28" data-testid="blog-teaser">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="eyebrow">{t("Dal blog")}</p>
            <h2 className="mt-4 text-2xl font-bold tracking-tight text-antracite sm:text-3xl lg:text-4xl">
              {t("Consigli digitali per la tua attività.")}
            </h2>
          </div>
          <Link to="/blog" className="btn-secondary" data-testid="blog-teaser-all">
            {t("Tutti gli articoli")}
            <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <article className="group card-soft flex h-full flex-col justify-between p-7 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-petrolio/10" data-testid={`blog-teaser-card-${i}`}>
                <div>
                  <p className="text-xs font-semibold uppercase tracking-[0.14em] text-antracite/50">
                    {format(parseISO(p.created_at), "d MMMM yyyy", { locale: dfLocale[lang] })} · {p.minutes} {t("min di lettura")}
                  </p>
                  <h3 className="mt-3 text-base font-bold leading-snug tracking-tight text-antracite sm:text-lg">{p.title}</h3>
                </div>
                <Link
                  to={`/blog/${p.slug}`}
                  data-testid={`blog-teaser-read-${i}`}
                  className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-elettrico transition-all duration-300 hover:gap-3.5"
                >
                  {t("Leggi l'articolo")}
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
